import {
  BookOpen,
  Briefcase,
  Calendar,
  LayoutDashboard,
  MapPin,
  Repeat2,
  Shield,
  Users,
} from 'lucide-react';
import { AppRole, Permission, PERMISSIONS, PLAN_CYCLE_APP_ROLES } from '../../lib/permissions';

export interface NavigationItem {
  key: string;
  href: string;
  icon: typeof LayoutDashboard;
  permissions: Permission[];
  adminOnly?: boolean;
  allowedAppRoles?: readonly AppRole[];
  tone: string;
}

export const navigationItems: NavigationItem[] = [
  {
    key: 'planCycles',
    allowedAppRoles: PLAN_CYCLE_APP_ROLES,
    href: '/plan-cycles',
    icon: Repeat2,
    permissions: [PERMISSIONS.lammRead, PERMISSIONS.servicesRead],
    tone: 'bg-indigo-100 text-indigo-700',
  },
  {
    key: 'midweekMeetingPlanning',
    href: '/midweek-meeting-planning',
    icon: BookOpen,
    permissions: [PERMISSIONS.lammRead],
    tone: 'bg-sky-100 text-sky-800',
  },
  {
    key: 'servicePlanning',
    href: '/service-planning',
    icon: Briefcase,
    permissions: [PERMISSIONS.servicesRead],
    tone: 'bg-amber-100 text-amber-800',
  },
  {
    key: 'fieldService',
    href: '/field-service',
    icon: MapPin,
    permissions: [PERMISSIONS.fieldServiceRead],
    tone: 'bg-slate-100 text-slate-700',
  },
  {
    key: 'absences',
    href: '/absences',
    icon: Calendar,
    permissions: [PERMISSIONS.absencesRead],
    tone: 'bg-rose-100 text-rose-800',
  },
  {
    key: 'congregation',
    href: '/congregation',
    icon: Users,
    permissions: [PERMISSIONS.publishersWrite],
    allowedAppRoles: ['admin', 'lamm_overseer'],
    tone: 'bg-slate-100 text-slate-700',
  },
  {
    key: 'userManagement',
    href: '/users',
    icon: Shield,
    permissions: [PERMISSIONS.usersRead, PERMISSIONS.permissionsManage],
    adminOnly: true,
    tone: 'bg-violet-100 text-violet-800',
  },
];

export const getVisibleNavigationItems = (
  hasAnyPermission: (permissions: Permission[]) => boolean,
  appRole?: string
) =>
  navigationItems.filter(
    item =>
      (!item.adminOnly || appRole === 'admin') &&
      (!item.allowedAppRoles || item.allowedAppRoles.some(role => role === appRole)) &&
      hasAnyPermission(item.permissions)
  );
